/* global Config nSdkInstance */
import { get } from 'lodash';
import PlayerManager from '../PlayerManager';
import { PlayerEvent } from '../../../player/utils';

class NielsenDTVRManager extends PlayerManager {
  currentPlaybackTime = 0;

  get enabled() {
    return !!nSdkInstance && !!this._videoMetadata.custom_attributes.nielsen_analytics_enabled;
  }

  get events() {
    return {
      [PlayerEvent.PlaybackFinished]: () => {
        nSdkInstance.ggPM('end', this.currentPlaybackTime);
      },
      [PlayerEvent.Destroy]: () => {
        // need to refactor player to use sourceunloaded here
        nSdkInstance.ggPM('end', this.currentPlaybackTime);
        nSdkInstance.ggPM('stop', this.currentPlaybackTime);
      },
      [PlayerEvent.SourceLoaded]: () => {
        nSdkInstance.ggPM('loadMetadata', this.createMetadataObject());
      },
      [PlayerEvent.Play]: () => {
        this._playbackStarted = true;
      },
      [PlayerEvent.TimeChanged]: () => {
        if (this._delegate._player.playerView) {
          this.currentPlaybackTime = this._delegate.currentTime;
        }
      },
      [PlayerEvent.Paused]: () => {
        nSdkInstance.ggPM('stop', this.currentPlaybackTime);
      },
      [PlayerEvent.Metadata]: data => {
        let parsedId3;
        const metadataFrames = get(data, 'metadata.frames', []);
        if (metadataFrames.length) {
          // fairplay
          const id3Frame = metadataFrames.find(
            frame => frame.info && /www.nielsen.com(.*)/.test(frame.info),
          );
          if (id3Frame) parsedId3 = id3Frame.info.replace(/\0.*$/g, '');
        } else {
          // widevine
          const messageData = get(data, 'metadata.messageData', null);
          if (messageData) {
            const parsedMetadata = messageData.match(/www.nielsen.com(.*)/);
            if (parsedMetadata.length === 2) {
              parsedId3 = parsedMetadata[0].replace(/\0.*$/g, '');
            }
          }
        }
        if (parsedId3) {
          nSdkInstance.ggPM('sendID3', parsedId3);
          this.id3Sent = true;
        }
      },
    };
  }

  createMetadataObject() {
    const channelName = this._airing.networkDetails?.name || this._airing.ott_mapping_id;

    return {
      type: 'content',
      channelName,
      adModel: '1',
    };
  }
}

export default NielsenDTVRManager;
